import { inject, Injectable } from '@angular/core';
import { ProductApiMeta, ProductApiSorting } from "src/app/models/product-api/product-api-reponse";
import { ProductListItem } from "src/app/models/product-list/productListItem";
import { ProductApiService } from '../../services/productApi/product-api.service';
import { SearchInput } from '../../services/productApi/search-input';
import { valueIsEan } from '../../services/helpers/ean-helper';

@Injectable({
  providedIn: 'root',
})
export class ProductListStore {
  private readonly productApiService = inject(ProductApiService);

  /**
   * Liste des produits
   */
  products: ProductListItem[];

  /**
   * Produit sélectionné pour voir le détail
   */
  currentSelectedProduct: ProductListItem = null;

  /**
   * Info sur la page et le tri alex.besnier@simphonis.com
   */
  productsMetas: ProductApiMeta;
  selectedSort: ProductApiSorting;
  currentSearchValue: string;

  reset() {
    this.products = [];
    this.currentSelectedProduct = null;
    this.productsMetas = null;
    this.selectedSort = null;
    this.currentSearchValue = null;
  }

  async getProduct(ean: string): Promise<ProductListItem> {
    if (!valueIsEan(ean)) {
      console.error('Invalid EAN: ' + ean);
      return;
    }

    const searchInput: SearchInput = { searchTerm: ean, sortBy: '', page: 1 };
    let response = await this.productApiService.sendSearchRequest(searchInput);
    const products = response.data.map(a => new ProductListItem(a));

    if (products.length === 0) {
      console.error('No product found for EAN: ' + ean);
      return;
    }

    if (products.length > 1) {
      console.error('Multiple products found for EAN: ' + ean);
      return;
    }

    return products[0];
  }
}
